import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@mui/styles'
import lang from '@/lang'

import { SelectInput } from '@/modules/base/components/inputs'
import theme from '@/theme'

const ListTagFilterInstance = forwardRef((props, ref) => {
  const { tagFilterValues, condition, conditionsCount, conditionIndex, onConditionChange } = props
  const classes = useStyles({ isLast: conditionsCount - 1 === conditionIndex })

  const tagSelectInputOptions = () => {
    return {
      name: 'tagSelectInputOptions',
      value: condition.values?.map(item => ({ label: item, value: item })),
      allowCreate: false,
      notAsync: true,
      options: tagFilterValues.map((tag) => {
        return {
          label: tag.label,
          value: tag.label,
          id: tag.id,
        }
      }),
      customSelectOptions: {
        placeholder: lang.tag.placeholderMultiple,
        clearable: false,
        isMulti: true,
        isClearable: false,
        menuPosition: 'fixed',
        closeMenuOnScroll: true,
      },
      handleChange: (event) => {
        const values = event?.map((tag) => tag.value) || []
        onConditionChange(conditionIndex, { ...condition, values })
      },
    }
  }

  const filterConditionOptions = {
    name: 'filterCondition',
    value: { value: condition.type },
    allowCreate: false,
    notAsync: true,
    options: [
      {
        label: lang.list.contains,
        value: 'contains',
      },
      {
        label: lang.list.notContains,
        value: 'notContains',
      },
    ],
    customSelectOptions: {
      placeholder: lang.list.contains,
      clearable: false,
      isSearchable: false,
      menuPosition: 'fixed',
    },
    handleChange: (event) => {
      const { value } = event
      onConditionChange(conditionIndex, { ...condition, type: value })
    },
  }

  return (
    <div ref={ref} className={classes.listTagFilterInstance}>
      <div className={classes.optionsContainer}>
        <SelectInput
          {...filterConditionOptions}
          styles={{
            control: (base) => ({
              ...base,
              maxHeight: 35,
            }),
          }}
        />
      </div>
      <SelectInput
        {...tagSelectInputOptions()}
        styles={{
          multiValue: (base) => ({
            ...base,
            backgroundColor: theme.white,
            border: `1px solid ${theme.borderColor}`,
            borderRadius: 25,
            height: 25,
            alignItems: 'center',
            padding: '0 5px',
          }),
          multiValueRemove: (base) => ({
            ...base,
            color: theme.primary,
          }),
        }}
      />
    </div>
  )
})

const useStyles = makeStyles((theme) => ({
  listTagFilterInstance: {
    padding: '15px 0',
    '&:first-of-type': {
      padding: '0px 0px 15px 0px',
    },
  },
  optionsContainer: {
    marginBottom: 15,
  },
  multiValueStyling: {
    height: 25,
    fontSize: '11px',
  },
}))

ListTagFilterInstance.propTypes = {
  conditionIndex: PropTypes.number,
  condition: PropTypes.object,
  onConditionChange: PropTypes.func,
  tagFilterValues: PropTypes.arrayOf(PropTypes.object),
  agGridReact: PropTypes.object,
  api: PropTypes.object,
  buttons: PropTypes.arrayOf(PropTypes.string),
  closeOnApply: PropTypes.bool,
  colDef: PropTypes.object,
  column: PropTypes.object,
  doesRowPassOtherFilter: PropTypes.func,
  filterChangedCallback: PropTypes.func,
  filterModifiedCallback: PropTypes.func,
  frameworkComponentWrapper: PropTypes.object,
  reactContainer: PropTypes.instanceOf(HTMLDivElement),
  rowModel: PropTypes.object,
  suppressMiniFilter: PropTypes.bool,
  valueGetter: PropTypes.func,
}

export default ListTagFilterInstance
